import styled from 'styled-components';
import {
  primaryColor1,
  primaryColor2,
  backgroundTertiary,
  backgroundColorDarkTertiary,
  colorTextDark,
  detailColorLight2
} from '../../../../../_metronic/variables.scss';

export const Container =styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0px 0px 16px 0px;
    height: 64px;
    max-width: 384px;
    width: 100%;
    padding: 12px 20px;
    font-family: 'Biennale Regular';
    background-color: ${backgroundTertiary};
    border-radius: 12px;
    border: ${({errorProps}) => errorProps ?
      '1px solid #FF7563' : `1px solid ${colorTextDark}` };

    &:focus-within {
      transition: border 0.4s;
      border: ${({errorProps}) => !errorProps ? `1px solid ${detailColorLight2}` : '1px solid #FF7563'};
    }

    .icon-senha svg {
      font-size: 16px;
      color: ${detailColorLight2};
      height: 20px;
      width: 20px;
    }

    .icon-senha svg path {
      fill: ${detailColorLight2};
    }

    @media(max-width: 768px){
      height: 56px;
    }

    > div {
      flex: 1;
      position: relative;

      small {
       font-size: 12px;
       flex: 1;
       color: ${props => props.theme.colors.background.secondary};
       padding-top: 1px;
       padding-bottom: 0;
       padding-left: 3px;
       padding-right: 3px;
       z-index: 10;
       border-top-left-radius: 3px;
       border-top-right-radius: 3px;
       border-bottom-right-radius: 3px;
       margin-left: -27px;
       top: calc(50% - 42px);
       background-color: #FF7563;
       position: absolute;
     }

     input {
      flex: 1;
      border: 0;
      height: 40px;
      background-color: ${backgroundTertiary};
      color: ${detailColorLight2};
      font-size: 16px;
      margin: 0px 10px;
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;

      -webkit-box-shadow: 0 0 0px 1000px ${backgroundTertiary} inset;

      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${colorTextDark};
        opacity: 1; /* Firefox */
        font-size: 16px;
        @media(max-width: 768px){
          font-size: 14px;
          min-height: 16px;
        }
      }

      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${colorTextDark};
      }

      ::-ms-input-placeholder { /* Microsoft Edge */
        color: ${colorTextDark};
      }

      @media(max-width: 768px){
        font-size: 14px;
        margin-top: 3px;
      }
    }
    input:-webkit-autofill {
      -webkit-text-fill-color: ${detailColorLight2} !important;
    }
}
  `;
